import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Toast { id: string; message: string; variant: 'success' | 'error' | 'info'; }
interface UiState { toasts: Toast[]; sidebarOpen: boolean; }

const initialState: UiState = { toasts: [], sidebarOpen: true };

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<Omit<Toast, 'id'>>) => {
      state.toasts.push({ ...action.payload, id: Date.now().toString() });
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
  },
});

export const { addToast, removeToast, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
